import script from "./PopupTool3TableList.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool3TableList.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool3TableList.vue?vue&type=style&index=0&id=7a8e60fe&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8e60fe"]])

export default __exports__